/**
 * This function returns bank name based on the issure code passed as the second parameter
 * @param {array} array
 * @param {string} issuerCode
 * @returns {string} - returns the bank name
 */
export const findIssuerName = (array, issuerCode) => {
    const bankName = array.find((x) => parseInt(x?.issuerCode) === parseInt(issuerCode));
    return bankName?.name;
};

/**
 *  This function returns corprate name based on the corprate id passed as the second parameter
 * @param {array} array
 * @param {number} corporateId
 * @returns {string} - returns corprate business name
 */
export const findCorporateName = (array, corporateId) => {
    const corporateName = array.find(
        (corporate) => parseInt(corporate?.id) === parseInt(corporateId)
    );
    return corporateName.businessName;
};
